import {
  executarManejoVidro,
  CATALOGO_VIDROS,
  type FerramentaVidro,
  type IdVidro,
  type ResultadoAcaoVidro,
} from '../didatico/manejoVidros'
import { atualizarObjeto } from './operacoes'
import type { CenaTabletop } from './tipos'

export interface ResultadoManejoVidroTabletop {
  readonly cena: CenaTabletop
  readonly resultado: ResultadoAcaoVidro
}

/**
 * Executa uma ação de manejo de vidro sobre UM veículo da cena, usando as
 * proteções e o insulfilm já gravados nesse veículo — a mesma lógica da
 * oficina de manejo de vidros (`didatico/manejoVidros.ts`), só que por carro
 * em vez de um veículo global único.
 *
 * `null` quando o veículo não existe ou não tem bloco `veiculo`. Uma ação
 * malsucedida (ferramenta incompatível, por exemplo) ainda devolve a cena
 * inalterada junto com o `resultado`, para o chamador mostrar a mensagem
 * didática sem precisar tratar isso como erro.
 */
export function executarManejoVidroNoVeiculo(
  cena: CenaTabletop,
  idVeiculo: string,
  idVidro: IdVidro,
  ferramenta: FerramentaVidro,
): ResultadoManejoVidroTabletop | null {
  const veiculo = cena.objetos.find((o) => o.id === idVeiculo)
  if (!veiculo?.veiculo) return null

  const resultado = executarManejoVidro(idVidro, ferramenta, veiculo.veiculo.protecoes, veiculo.veiculo.insulfilm)
  if (!resultado.sucesso) return { cena, resultado }

  const novaCena = atualizarObjeto(cena, idVeiculo, {
    veiculo: { vidros: { ...veiculo.veiculo.vidros, [idVidro]: resultado.novoEstado } },
  })
  return { cena: novaCena, resultado }
}

/** Restaura todos os vidros de um veículo para intacto — não mexe em proteções nem insulfilm. */
export function restaurarVidrosDoVeiculo(cena: CenaTabletop, idVeiculo: string): CenaTabletop {
  const veiculo = cena.objetos.find((o) => o.id === idVeiculo)
  if (!veiculo?.veiculo) return cena
  return atualizarObjeto(cena, idVeiculo, { veiculo: { vidros: {} } })
}

/** A ferramenta recomendada pelo catálogo para aquele vidro — mesmo critério da oficina de vidros. */
export function ferramentaRecomendada(idVidro: IdVidro): FerramentaVidro {
  return CATALOGO_VIDROS[idVidro].ferramentaRecomendada
}
